<template lang="pug">
div
  .form-block-title {{t(`helpers.placeholder.form_block.label.${form_block.handle}`, {default: form_block.name})}}
  .panel-sections
    .panels.rows-3(v-if="!noList")
      span
      .select
        span.selected
          span.value {{ selected_title }}
          span.caret
        select.for-panel-select(v-model="selected_id2" :disabled="disabled")
          option(:value="null", :selected="null === selected_id2") {{ first_choice }}
          option(
            v-for="obj in objects"
            :key="obj.id"
            :value="obj.id",
            :selected="obj.id === selected_id2"
          ) {{ obj.opt_title}}
          option(:value="-1" :selected="-1 === selected_id2") {{new_choice}}
    .panel-contents
      fb-content(
        :form_block="form_block" :entity_selected="noList"
        :entity_attrs="rfb.entity_attrs" @entity_attrs:input="rfb.entity_attrs=$event;registration.doTouch()"
        :custom_attrs="rfb.custom_attrs" @custom_attrs:input="rfb.custom_attrs=$event;rfb.has_changed=true"
        :member_attrs="rfb.member_attrs" @member_attrs:input="rfb.member_attrs=$event;registration.doTouch()"
      )
</template>
<script>
import helper_relation_objects from '../../form_block/relation_objects'
import FbContent from '../../form_block/_content'
export default{
  components: {FbContent},
  mixins: [helper_relation_objects],
  props: {
    form_block: {type: Object, required: true,},
    parent_entity_id: {type: [Number], required: false}, // required, needed to load in relation objects
  },
  watch: {
    "registration.person_id"(){
      if (this.registration.new_person_was) return
      this.relation_objects()
    },
    "form_block.prefetch_new_element"(){ this.prefetchNew("reg_store/people_addresses") },
  },
  computed: {
    registration(){ return this.state.current_reg },
    noList(){ return this.objects.length===0 },
    rfb(){ return this.state.current_reg.find_rblock(this.form_block)},
    disabled(){ return !this.registration.person_id || !this.parent_entity_id}
  },
  created(){
    this.relation_objects()
  },
}
</script>